module.exports = __webpack_public_path__ + "img/图0-2千斤顶的装配图.58742e4f.png";